(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Correção de confiabilidade: abertura do carrinho (achado 13/08,
     estendida pro site inteiro em 13/08 — antes só valia na PDP)

     `assets/cart-drawer.js` (arquivo padrão do Dawn, não editado por
     nós) tem um comentário do próprio time da Shopify admitindo que a
     animação de abrir o carrinho "não parece disparar sempre" e usa
     um `setTimeout(fn)` (sem tempo definido) pra tentar contornar —
     frágil: se o navegador processar o timeout dentro do MESMO frame
     de renderização em que a classe é aplicada, a transição CSS não é
     acionada e o painel fica preso fora da tela (medido em 13/08:
     `translateX` igual à própria largura do painel — o carrinho "abre"
     só o fundo escurecido, sem o conteúdo entrar).

     Confirmado por causa raiz: esse comportamento já existia no tema
     PUBLICADO antes de qualquer mudança nossa (arquivo idêntico byte a
     byte). Carregado aqui — global, todas as páginas — porque o ícone
     de carrinho no cabeçalho abre o mesmo componente em qualquer lugar
     do site, não só na PDP; a versão anterior deste fix (13/08, mesmo
     dia) só cobria a PDP, por estar dentro de vistavie-product.js.

     Fix: substituir o `setTimeout(fn)` por duplo `requestAnimationFrame`
     (garante que o navegador pinta o estado FECHADO num frame antes de
     aplicar a classe que dispara a transição pro estado ABERTO — mais
     confiável que o timeout sem tempo do Dawn) + uma rede de segurança
     via `setTimeout`, porque `requestAnimationFrame` NUNCA dispara com
     a aba em segundo plano (comportamento padrão de todo navegador,
     confirmado testando nesta sessão) — sem essa rede, o carrinho
     ficaria preso invisível se o "abrir" acontecesse com a aba oculta.

     Interceptamos `CartDrawer.prototype.open` depois que a classe
     original já foi definida — não editamos `cart-drawer.js`.
     ------------------------------------------------------------------ */

  function vvFixCartDrawerAnimation() {
    if (!window.customElements || !window.customElements.whenDefined) return;
    /* `cart-drawer.js` e este arquivo são ambos carregados com `defer`
       perto do fim do body, nesta ordem — mas `whenDefined` é a forma
       correta (padrão do navegador) de esperar a classe existir, em
       vez de depender da ordem exata de carregamento. */
    window.customElements.whenDefined('cart-drawer').then(function () {
      var proto = window.customElements.get('cart-drawer').prototype;
      if (proto.vvOpenFixed) return;
      proto.vvOpenFixed = true;
      vvPatchCartDrawerOpen(proto);
    });
  }

  function vvPatchCartDrawerOpen(proto) {
    proto.open = function (triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      var cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

      var el = this;
      var vvOpened = false;
      var vvOpen = function () {
        if (vvOpened) return;
        vvOpened = true;
        el.classList.add('animate', 'active');
      };
      requestAnimationFrame(function () {
        requestAnimationFrame(vvOpen);
      });
      setTimeout(vvOpen, 100);

      this.addEventListener(
        'transitionend',
        function () {
          var containerToTrapFocusOn = el.classList.contains('is-empty')
            ? el.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          var focusElement = el.querySelector('.drawer__inner') || el.querySelector('.drawer__close');
          if (typeof trapFocus === 'function') trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    };
  }

  vvFixCartDrawerAnimation();
})();
